/** Solid primary action (STYLE.md "Buttons"): --cta fill, 8px radius. For links and buttons alike. */
export const ctaCls =
  'inline-flex h-9 shrink-0 items-center justify-center gap-1.5 rounded-lg bg-cta px-4 text-sm font-medium text-cta-fg transition-colors hover:bg-cta-hover';
/** Secondary text link next to a CTA. */
export const textLinkCls =
  'inline-flex h-9 items-center rounded-lg px-3 text-sm font-medium text-fg transition-colors hover:bg-hover';
